import { createReducer, on } from "@ngrx/store";
import {
  TreatmentPageActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { TreatmentContract } from "./treatment-contract";

export const featureKey = "treatmentContract";

export interface TreatmentContractState extends TreatmentContract {
  insuranceInvalidated: boolean;
  insuranceTimestamp: Date;
  loading: boolean;
  validationErrors: string[];
}

export const initialState: TreatmentContractState = {
  contractId: undefined,
  patient: undefined,
  practiceId: undefined,
  practiceLocationId: undefined,
  validationErrors: [],
  loading: true,
  insuranceInvalidated: false,
  insuranceTimestamp: null,
};

export const reducer = createReducer(
  initialState,
  on(TreatmentPageActions.loadContract, (state, { contractId }) => ({
    ...state,
    contractId,
  })),
  on(TreatmentPlanApiActions.loadSuccess, (state, { contract }) => ({
    ...state,
    diagnosisCodes: contract.DiagnosisCodes,
    patient: contract.Patient
      ? {
          id: contract.Patient.Id,
          firstName: contract.Patient.FirstName,
          lastName: contract.Patient.LastName,
        }
      : null,
    practiceId: contract.PracticeId,
    practiceLocationId: contract.PracticeLocationId,
    contractId: contract.ContractId,
  })),
  on(
    TreatmentPlanApiActions.validateContractSuccess,
    (state, { validationErrors }) => ({ ...state, validationErrors })
  ),
  on(TreatmentPageActions.loadContract, (state) => ({
    ...state,
    loading: true,
  })),
  on(TreatmentPlanApiActions.loaded, (state) => ({ ...state, loading: false })),
  on(TreatmentPageActions.insuranceInvalidated, (state) => ({
    ...state,
    insuranceInvalidated: true,
  })),
  on(
    TreatmentPlanApiActions.insuranceTimestampLoadSuccess,
    (state, { timestamp }) => {
      if (state.insuranceTimestamp === timestamp) {
        return state;
      }
      return {
        ...state,
        insuranceTimestamp: timestamp,
      };
    }
  ),
  on(TreatmentPlanApiActions.aobSaveSuccess, (state, { timestamp }) => ({
    ...state,
    insuranceTimestamp: timestamp,
  }))
);
